
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/_error", function() {
      var page = require("next/dist/pages/_error")
      if(module.hot) {
        module.hot.accept("next/dist/pages/_error", function() {
          if(!next.router.components["/_error"]) return
          var updatedPage = require("next/dist/pages/_error")
          next.router.update("/_error", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  